export class EmployeeTypesReq{
    employeeTypesId: number;

    constructor(employeeTypesId: number){
        employeeTypesId = employeeTypesId;
    }
}